// extracted by mini-css-extract-plugin
export default {"insurance__section":"Insurance_insurance__section__1-dZb","insurance__date":"Insurance_insurance__date__jOFgV"};